import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import {Icon} from "..";
import "./Chip.scss";
import {defineMessages, injectIntl} from "react-intl";

const CLEAR_ICON_ACCESSIBILITY_TEXT = defineMessages({
  'title': {
    id: 'Chip.clear.iconTitle',
    defaultMessage: 'Clear bubble icon'
  },
  'desc': {
    id: 'Chip.clear.iconDesc',
    defaultMessage: 'Clear icon to remove selected attributes'
  }
});

function Chip({
  className,
  text,
  intl,
  handleClickRemove
}) {
  const classnames = cx(
    "Chip",
    className
  );

  return (
    <div className={classnames} >
      <span>{text}</span>
      <div className={"Chip__clearIcon_wrapper"} onClick={handleClickRemove}>
        <Icon
          className="Chip__clearIcon_svg"
          desc={intl.formatMessage(CLEAR_ICON_ACCESSIBILITY_TEXT.desc)}
          id="Chip__clear_icon"
          name="close"
          title={intl.formatMessage(CLEAR_ICON_ACCESSIBILITY_TEXT.title)}
          styles={{width: "12px", height: "12px", fill: "#677383"}}
        />
      </div>
    </div>
  );
}

Chip.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ]),
  text: PropTypes.string.isRequired
};

export default injectIntl(Chip);
